import ForexChart from './ForexChart'

/**
 * A wrapper for ForexChart that provides play mode functionality
 */
const PlayableForexChart = ({ 
  data, 
  orders, 
  symbol, 
  timeframe, 
  height = 500, 
  mode = 'normal', 
  isPlaying = false,
  visibleData = [],
  pausedViewportRange = null,
  enableDynamicLoading = false,
  backtestStartTimestamp = null,
  backtestEndTimestamp = null,
  onLoadMoreData = null
}) => {
  const displayData = mode === 'play' ? visibleData : data
  const allowScroll = mode === 'normal' || !isPlaying

  return (
    <ForexChart
      data={displayData}
      orders={orders}
      symbol={symbol}
      timeframe={timeframe}
      height={height}
      allowScroll={allowScroll}
      pausedViewportRange={pausedViewportRange}
      enableDynamicLoading={enableDynamicLoading}
      backtestStartTimestamp={backtestStartTimestamp}
      backtestEndTimestamp={backtestEndTimestamp}
      onLoadMoreData={onLoadMoreData}
    />
  )
}

export default PlayableForexChart
